<template>
  <UCard v-show="$pwa?.needRefresh" variant="outline" class="z-20 top-5 left-0 right-0 fixed shadow-xl mx-auto max-w-full w-xl h-auto">
    <template #header>
      <div class="text-xl">
        Neue Inhalte verfübar!
      </div>
    </template>
    <div>Klicke auf <span class="font-semibold">Update</span>, um die App zu aktualisieren.</div>
    <template #footer>
      <div class="flex justify-end">
        <NButtonGroup>
          <NButton type="primary" @click="() => $pwa?.updateServiceWorker()">
            Update
          </NButton>
        </NButtonGroup>
      </div>
    </template>
  </UCard>
</template>
